import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CurrTierEvent, CurrTierEventType } from './authFlowSetupEdit.component';

@Component({
  selector: 'auth-flow-currency-tier',
  templateUrl: './auth-flow-currency-tier.component.html',
  providers: [],
})
export class AuthFlowCurrencyTierComponent implements OnChanges {
  @Input()
  protected editForm: FormGroup<any>;
  @Input()
  protected visuals: any;
  @Input()
  protected lookups: any[];
  @Input()
  protected componentAvailableCurrencies: any[];
  @Input()
  protected componentCurrCd: String;
  @Input()
  protected viewUpdated: boolean;
  @Input()
  protected isReadOnly = false;
  @Output()
  protected tierChange: EventEmitter<CurrTierEvent> = new EventEmitter<CurrTierEvent>();
  protected currTierForm: FormGroup<any>;
  protected previousCurrCd: String;

  constructor(private fb: FormBuilder) {}

  ngOnChanges(): void {
    this.currTierForm = this.fb.group({
      tiers: this.fb.array(
        this.editForm
          .get('policyConfig')
          .get('tiers')
          ['controls'].filter((t) => t.value.currCd == this.componentCurrCd),
      ),
    });
    this.previousCurrCd = this.componentCurrCd;
  }

  removeClick() {
    this.tierChange.emit({
      currCd: this.componentCurrCd,
      event: CurrTierEventType.REMOVE_TIER_COMPONENT,
    });
  }

  changeComponentSelectedCurrCd(event: any) {
    this.tierChange.emit({
      currCd: event.text,
      oldCurrCd: this.previousCurrCd,
      event: CurrTierEventType.CHANGE_CURR,
    });
  }

  addTiersClick() {
    this.tierChange.emit({
      currCd: this.componentCurrCd,
      event: CurrTierEventType.ADD_TIER,
    });
  }

  removeTiersClick(i: number) {
    this.tierChange.emit({
      currCd: this.componentCurrCd,
      tierIndex: i,
      event: CurrTierEventType.REMOVE_TIER,
    });
  }

  minAmountChangedClick(i: number) {
    this.tierChange.emit({
      currCd: this.componentCurrCd,
      tierIndex: i,
      tierItem: this.currTierForm.get('tiers')['controls'][i],
      event: CurrTierEventType.MIN_AMOUNT_CHANGED,
    });
  }

  maxAmountChangedClick(i: number) {
    this.tierChange.emit({
      currCd: this.componentCurrCd,
      tierIndex: i,
      tierItem: this.currTierForm.get('tiers')['controls'][i],
      event: CurrTierEventType.MAX_AMOUNT_CHANGED,
    });
  }

  removeWorkflowClick(i: number, j: number) {
    this.tierChange.emit({
      currCd: this.componentCurrCd,
      tierItem: this.currTierForm.get('tiers')['controls'][i],
      tierIndex: i,
      workflowIndex: j,
      event: CurrTierEventType.REMOVE_WORKFLOW,
    });
  }

  addWorkflowClick(i: number) {
    this.tierChange.emit({
      currCd: this.componentCurrCd,
      tierItem: this.currTierForm.get('tiers')['controls'][i],
      tierIndex: i,
      event: CurrTierEventType.ADD_WORKFLOW,
    });
  }

  tierUpdatedEvent(i: number) {
    this.tierChange.emit({
      tierItem: this.currTierForm.get('tiers')['controls'][i],
      tierIndex: i,
      currCd: this.componentCurrCd,
      event: CurrTierEventType.TIER_UPDATED,
    });
  }
}
